'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnd2EndLaunchUrl = undefined;

var _utils = require('./utils');

var getEnd2EndLaunchUrl = exports.getEnd2EndLaunchUrl = function getEnd2EndLaunchUrl(playerSessionID, data) {
  return (0, _utils.postProtected)('/bingo/launch-end2end', playerSessionID, data);
};

exports.default = {
  getEnd2EndLaunchUrl: getEnd2EndLaunchUrl
};